import './Loader.css';

function Loader({ className = '' }) {
  return <div className={`loader ${className}`} aria-label="Loading" />;
}

export default Loader;
